(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const track = document.querySelector(".js-brand-slider-track");
    if (!track) return;

    const slides = Array.from(track.children);
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add("brand-slider__slide--clone");
      track.appendChild(clone);
    });

    let scrollSpeed = 0.5;
    let currentScroll = 0;

    function animate() {
      currentScroll += scrollSpeed;
      if (currentScroll >= track.scrollWidth / 2) {
        currentScroll = 0;
      }
      track.style.transform = `translateX(-${currentScroll}px)`;
      requestAnimationFrame(animate);
    }

    animate();
  });

  } catch(e) { console.error(e); }
})();
})();
